import React from 'react'
import Layout from '../Components/Layout/Layout'
import HomeComponent from '../Components/HomeComponent'

const Home = () => {
  return (
    <>
    <Layout>
        <HomeComponent />
    </Layout>
    </>
  )
}

export default Home

